/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Plum = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="12"
    height="19"
    fill="none"
    viewBox="0 0 12 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.90881 18.36C2.4288 18.36 0 15.5664 0 11.568C0 9.7824 0.472801 8.2056 1.3656 7.008C2.2248 5.856 3.4224 5.1168 4.82401 4.8696L4.94881 4.848L4.92001 4.7256C4.60801 3.3624 3.74881 2.0376 2.6616 1.2432L3.5112 0C4.14481 0.456 4.70161 1.0368 5.20801 1.7712L5.30401 1.9104L5.40481 1.7736C6.17761 0.72 7.43041 0.18 9.34081 0.0744C9.81841 1.164 10.0416 2.0352 10.0416 2.8056C10.0416 3.8976 9.59521 4.7568 8.75281 5.2968L8.58481 5.4048L8.75761 5.5032C10.704 6.6096 11.82 8.82 11.82 11.568C11.8176 15.5664 9.38881 18.36 5.90881 18.36ZM5.90881 6.264C3.252 6.264 1.536 8.3448 1.536 11.568C1.536 14.7408 3.2928 16.872 5.90881 16.872C8.52481 16.872 10.2816 14.7408 10.2816 11.568C10.2816 8.3472 8.56561 6.264 5.90881 6.264ZM8.36401 1.5384C6.96241 1.764 6.22081 2.484 6.22081 3.624C6.22081 4.0008 6.30481 4.3728 6.47281 4.7304L6.51121 4.812L6.60001 4.7976C8.35201 4.512 8.71921 3.504 8.71921 2.712C8.71921 2.3544 8.64241 1.9848 8.49361 1.6104L8.45761 1.5216L8.36401 1.5384Z" fill="currentColor" />
  </svg>
);

Plum.propTypes = propTypes;

export default Plum;
